import users from "../../data/users";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import { useState } from "react";
import { Button } from "@mui/material";

const UserNavigation = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [userId, setUserId] = useState();

  const handleMonthClick = (value) => {
    setSelectedDate(value);
    //console.log('Mês selecionado:', value);
  };



  const handleButtonClickTimesheet = (type) => {
    if (!userId) return;

    const year = selectedDate.getFullYear();
    const month = String(selectedDate.getMonth() + 1);

    const url = `/timesheet/removed/${year}/${month}/${userId}`;

    window.open(url, '_blank');
  };

  const handleButtonClick = (type) => {
    if (!userId) return;

    const year = selectedDate.getFullYear();
    const month = String(selectedDate.getMonth() + 1);

    // if(){

    // }
    const url = `/timesheet/${type}/${year}/${month}/${userId}`;

    window.open(url, '_blank');
  };

  return (
    <div>
      <nav className="flex justify-center gap-4 mt-4">
        {users.map((user) => {
          if (user.id === 0) return null; // ignora user.id === 0
          const isSelected = user.id.toString() === userId;
          return (
            <Button
              variant="contained"
              key={user.id}
              onClick={() => setUserId(user.id)}
              className={`px-4 py-2 rounded-md ${isSelected ? 'bg-green-500' : 'bg-blue-500'
                } text-white hover:bg-blue-600`}
            >
              {user.name}
            </Button>
          );
        })}
      </nav>

      {userId && (
        <div className="flex justify-center mt-8">
          <Calendar
            value={selectedDate}
            onChange={setSelectedDate}
            view="year"
            onClickMonth={handleMonthClick}
            maxDetail="year"
          />
        </div>
      )}

      {userId && (
        <div className="flex justify-center mt-4">
          <div className="flex space-x-2">
            <button
              onClick={() => handleButtonClickTimesheet()}
              className="flex items-center px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-indigo-600 hover:text-white"
            >
              🕒 Timesheet
            </button>
            <button
              onClick={() => handleButtonClick('first-half')}
              className="flex items-center px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-indigo-600 hover:text-white"
            >
              📅 First Half
            </button>
            <button
              onClick={() => handleButtonClick('second-half')}
              className="flex items-center px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-indigo-600 hover:text-white"
            >
              📅 Second Half
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserNavigation;
